import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { SocialService } from './../../service/social.service';
import { Component, OnInit } from '@angular/core';
import { Social } from '../../model/social';

@Component({
  selector: 'app-admin-social',
  templateUrl: './admin-social.component.html',
  styleUrls: ['./admin-social.component.css']
})
export class AdminSocialComponent implements OnInit {

  itens: Social[];

  constructor(private service: SocialService, private messageService: MessageService) { }

  ngOnInit() {
    this.service.listar().subscribe(ret => {
      this.itens = ret;
    });
  }

  atualizar() {
    this.itens.forEach(value => {
      const task = this.service.salvar(value);
      task.then(ret => {
        this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Registro Atualizado com Sucesso' });
      }).catch(e => {
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao Atualizar' });
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/admin-social/admin-social.component.ts